function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import findTabbable, { findFocusable } from './elementStateHelpers';
import keyCodes from './keyboardEventCodes';

var isActive = function isActive(el) {
  return el === document.activeElement;
};

var FocusTrapper = /*#__PURE__*/function () {
  function FocusTrapper(rootElement) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref$strategy = _ref.strategy,
        strategy = _ref$strategy === void 0 ? 'tabbable' : _ref$strategy,
        _ref$allowTabTraversa = _ref.allowTabTraversal,
        allowTabTraversal = _ref$allowTabTraversa === void 0 ? true : _ref$allowTabTraversa,
        _ref$allowArrowKeys = _ref.allowArrowKeys,
        allowArrowKeys = _ref$allowArrowKeys === void 0 ? false : _ref$allowArrowKeys;

    _classCallCheck(this, FocusTrapper);

    _defineProperty(this, "_isArrowDown", function (keyCode) {
      return keyCode === keyCodes.ARROW_DOWN;
    });

    _defineProperty(this, "_isArrowUp", function (keyCode) {
      return keyCode === keyCodes.ARROW_UP;
    });

    _defineProperty(this, "_isTab", function (keyCode) {
      return keyCode === keyCodes.TAB;
    });

    _defineProperty(this, "_getCheckedEl", function (interactable) {
      return interactable.filter(function (el) {
        return el.getAttribute('aria-checked') === 'true';
      })[0];
    });

    this.rootElement = rootElement;
    this._handleKeydown = this._handleKeydown.bind(this);
    this._allowArrowKeys = allowArrowKeys;
    this._strategy = strategy;
    this._allowTabTraversal = allowTabTraversal;
    this._findEls = strategy === 'tabbable' ? findTabbable : findFocusable;
  }

  _createClass(FocusTrapper, [{
    key: "_isTabLike",
    value: function _isTabLike(keyCode) {
      return this._isTab(keyCode) || this._allowArrowKeys && (this._isArrowUp(keyCode) || this._isArrowDown(keyCode));
    }
  }, {
    key: "_getDirection",
    value: function _getDirection(event) {
      var keyCode = event.keyCode,
          shiftKey = event.shiftKey;

      var isTab = this._isTab(keyCode);

      var isArrowDown = this._isArrowDown(keyCode);

      var isArrowUp = this._isArrowUp(keyCode);

      if (this._allowArrowKeys && (isArrowDown || isArrowUp)) {
        return isArrowDown ? 'forward' : 'backward';
      }

      if (this._allowTabTraversal && isTab) return shiftKey ? 'backward' : 'forward';
      return null;
    }
  }, {
    key: "_handleKeydown",
    value: function _handleKeydown(event) {
      var keyCode = event.keyCode;

      if (typeof this.onEscape === 'function' && (!this._allowTabTraversal && this._isTab(keyCode) || keyCode === keyCodes.ESCAPE)) {
        this.onEscape();
        event.stopPropagation();
      }

      var nextInteractable = this._getNextInteractable(this._getDirection(event));

      if (nextInteractable) {
        nextInteractable.focus();
        event.preventDefault();
      }
    }
  }, {
    key: "_getNextInteractable",
    value: function _getNextInteractable(direction) {
      if (!direction) return null;

      var interactable = this._findEls(this.rootElement);

      for (var i = 0; i < interactable.length; i += 1) {
        var isLast = i === interactable.length - 1;
        var isFirst = i === 0;
        var isActiveElement = isActive(interactable[i]);
        if (isActiveElement && isLast && direction === 'forward') return interactable[0];
        if (isActiveElement && isFirst && direction === 'backward') return interactable.slice(-1)[0];
        if (isActiveElement && direction === 'forward') return interactable[i + 1];
        if (isActiveElement && direction === 'backward') return interactable[i - 1];
      }

      return null;
    }
  }, {
    key: "setOnEscape",
    value: function setOnEscape(onEscape) {
      this.onEscape = onEscape;
    }
  }, {
    key: "_isInTrap",
    value: function _isInTrap() {
      return this.rootElement.contains(document.activeElement) || this.rootElement === document.activeElement;
    }
  }, {
    key: "_ensureFocusInTrap",
    value: function _ensureFocusInTrap() {
      var interactable = this._findEls(this.rootElement);

      var firstInteractable = interactable[0];
      var firstFocusedEl = this._getCheckedEl(interactable) || firstInteractable;
      var isNotInTrap = !this._isInTrap();

      if (isNotInTrap && firstFocusedEl) {
        firstFocusedEl.focus();
      } else if (isNotInTrap) {
        this.rootTabIndex = this.rootElement.getAttribute('tabindex');
        this.rootElement.setAttribute('tabindex', this.rootTabIndex || 0);
        this.rootElement.focus();
      }
    }
  }, {
    key: "trap",
    value: function trap() {
      var _this = this;

      if (!this._isHandlerActive) {
        this.rootElement.addEventListener('keydown', this._handleKeydown);
        this._isHandlerActive = true;
      }

      if (this._isInTrap()) return Promise.resolve(true);

      if (!this.rootElement) {
        throw new Error('no root element provided to trap focus');
      }

      return new Promise(function (resolve) {
        setTimeout(function () {
          if (!_this._isInTrap()) {
            _this._previouslyFocusedEl = document.activeElement;
          }

          _this._ensureFocusInTrap();

          return resolve(true);
        });
      });
    }
  }, {
    key: "release",
    value: function release() {
      var _this2 = this;

      if (this._isHandlerActive) {
        this.rootElement.removeEventListener('keydown', this._handleKeydown);
        this._isHandlerActive = false;
      }

      if (!this._isInTrap()) return Promise.resolve(true);
      this.rootElement.setAttribute('tabindex', this.rootTabIndex);
      return new Promise(function (resolve) {
        setTimeout(function () {
          if (!_this2._previouslyFocusedEl) return resolve(true);

          _this2._previouslyFocusedEl.focus();

          _this2._previouslyFocusedEl = null;
          return resolve(true);
        });
      });
    }
  }]);

  return FocusTrapper;
}();

export { FocusTrapper as default };